import { Component, OnInit } from '@angular/core';
import { RentalsService } from '../../../../../services/rentals.service';
import { HelpersService } from '../../../../../services/helpers.service';
import moment from 'moment';
import * as XLSX from 'xlsx';

import * as json2csv from 'json2csv'; // convert json file to csv

@Component({
  selector: 'app-rental-reports',
  templateUrl: './rental-reports.component.html',
  styleUrls: ['./rental-reports.component.scss'],
})
export class RentalReportsComponent implements OnInit {
  public partnerID: number;
  public availableReports: any = [];
  public columns: any = [];
  public reports: any = [];
  public selectedReport: any = null;
  public selectedReportID: number = null;
  public reportData: any = [];
  public startDate: any;
  public endDate: any;
  public loading: boolean = false;
  public runningReport: boolean = false;
  public reportRan: boolean = false;
  public useTableBorder: boolean = true;
  public csvFileName = `report.csv`;

  Json2csvParser = json2csv.Parser;

  constructor(
    public rentalsService: RentalsService,
    public helpersService: HelpersService,
  ) {
    this.partnerID = this.helpersService.getPartnerId();
  }

  ngOnInit() {
    this.loading = true;
    this.rentalsService.getRentalReportList().subscribe((availableReports) => {
      this.reports = availableReports;
      this.availableReports = [];

      availableReports.forEach((report) => {
        var filteredData = this.availableReports.filter((filter) => {
          return filter.label === report.ReportGroup;
        });
        if (filteredData.length > 0) {
          filteredData[0].items.push({
            label: report.ReportName,
            value: report.ID,
          });
        } else {
          this.availableReports.push({
            label: report.ReportGroup,
            items: [{ label: report.ReportName, value: report.ID }],
          });
        }
      });
      this.loading = false;
    });

    this.startDate = new Date();
    this.startDate.setMonth(this.startDate.getMonth() - 1);
    this.endDate = new Date();
    this.endDate.setDate(this.startDate.getDate() + 2);
  }

  runReport() {
    this.runningReport = true;
    this.reportRan = false;
    this.rentalsService
      .getRentalReport(
        this.partnerID,
        this.selectedReportID,
        moment(this.startDate).format('YYYYMMDD'),
        moment(this.endDate).format('YYYYMMDD'),
      )
      .subscribe(
        (reportData) => {
          this.reportData = reportData;
          this.columns = [];
          if (reportData && reportData.length > 0) {
            for (var prop in reportData[0]) {
              this.columns.push(prop);
            }
          }
          //this.useTableBorder = reportData.length > 0 && reportData[0].length > 0 && reportData[0][0].length > 0 ? true : false;
          this.runningReport = false;
          this.reportRan = true;
        },
        (error) => {
          this.runningReport = false;
          this.reportRan = false;
        },
      );
  }

  public downloadFile() {
    var report = this.reports
      .filter((x) => {
        return x.ID === this.selectedReportID;
      })
      .pop();

    var ws = XLSX.utils.json_to_sheet(this.reportData);
    var wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Data');
    XLSX.writeFile(wb, report.ReportName + '.xlsx');

    //var f = XLSX.utils.json_to_sheet(this.reportData);
    //let file = new Blob([this.reportData], { type: 'text/xslx;charset=utf-8' });
    //saveAs(file, this.selectedReport.toLowerCase() + ".xslx");

    //console.log(this.reportData);
    //let csvData = this.convertToCSV(this.reportData);
    //let file = new Blob([csvData], { type: 'text/csv;charset=utf-8' });
    //saveAs(file, this.selectedReport.toLowerCase() + ".csv");
  }

  public convertToCSV(objArray: any, fields?) {
    let json2csvParser = new this.Json2csvParser({
      opts: fields,
      quote: '"',
      withBOM: true,
      header: false,
    });
    let csv = json2csvParser.parse(objArray);
    return csv;
  }

  public getReportDescription() {
    if (this.selectedReportID) {
      var report = this.reports
        .filter((x) => {
          return x.ID === this.selectedReportID;
        })
        .pop();
      if (report) {
        return report.ReportDescription;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }
}
